import React from 'react';
import Page from "../Components/Page";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import EditableReactTableV2 from "../Components/ReactTable/EditableReactTableV2";
import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import {INDEX_FIELD} from "../Components/ReactTable/common_custom_columns";
import {EditFormDropdownInputField, EditFormNumberInputField,} from "../Components/ReactTable/EditRecordForm";
import {toastError} from "../../utils/toast";
import {toast} from "react-toastify";

const InflationFactorService = () => {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/inflationFactors/`
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl})

    const customColumns = [
        {header: "Universe", accessorKey: "universe"},
        {header: "Store Classification", accessorKey: "storeClassification"},
        {header: "Inflation Factor", accessorKey: "inflationFactor"}
    ]

    const universeOptions = [
        {label: "NATURAL ENHANCED", value: "natural enhanced"},
        {label: "REGIONAL GROCERY", value: "regional grocery"},
        {label: "DEFAULT", value: "default"}
    ]

    const storeClassificationOptions = [
        {label: "INDIE", value: "indie"},
        {label: "CHAIN", value: "chain"},
        {label: "DEFAULT", value: "default"}
    ]

    const getOnRowDeleteConfirmedWrapper = async (row) => {
        if (row.universe === "default" && await row.storeClassification === "default") {
            toastError(toast, 'You cannot delete the default record');
            return;
        }
        return onRowDeleteConfirmed(row);
    };

    const validatePreSave = ({rows, form}) => {
        const addedNewRow = form.getValues();
        const rawRecordsFiltered = rows.map(row => row.original).filter(row => row.universe === addedNewRow.universe && row.storeClassification === addedNewRow.storeClassification);
        const hasDuplicate = rawRecordsFiltered.length > 0 && addedNewRow.index !== rawRecordsFiltered[0].index;

        const inflationFactorValue = form.getValues('inflationFactor');
        const hasMoreThan4Digits = Number.isFinite(inflationFactorValue) && !Number.isInteger(inflationFactorValue * 10000);

        if (hasDuplicate) {
            form.setError('index', {type: 'custom', message: [`Mapping already exists`]});
        }
        if (hasMoreThan4Digits) {
            form.setError('inflationFactor', {
                type: 'custom',
                message: [`Inflation Factor must have 4 digits or less`]
            });
        }
        return !hasDuplicate && !hasMoreThan4Digits;
    };

    return <Page name={"Inflation Factor Service"} beta={true}>
        <LoadingWrapper loading={loading}>
            <EditableReactTableV2
                data={data.data}
                filterable={true}
                columns={customColumns}
                initialState={{pagination: {pageSize: 10}, sorting: [{id: 'universe', desc: false}]}}
                validatePreSave={validatePreSave}
                onRowEditConfirmed={onRowEditConfirmed}
                onRowDeleteConfirmed={getOnRowDeleteConfirmedWrapper}
                editTable={[
                    INDEX_FIELD,
                    {id: "universe", defaultValue: 'default', Component: args => <EditFormDropdownInputField {...args} options={universeOptions} isRequired />},
                    {id: "storeClassification", defaultValue: 'default', Component: args => <EditFormDropdownInputField {...args} options={storeClassificationOptions} isRequired />},
                    {id: "inflationFactor", Component: args => <EditFormNumberInputField {...args} isRequired />}
                ]}
            />
        </LoadingWrapper>
    </Page>;
};

export default InflationFactorService;